import React, { useState } from "react";
import InView from "react-intersection-observer";
import HeaderAnim from '../utils/animations/textRevealAnimation';

export default function ProcessFlow(props) {
  const { title, header, subHeader, items, classes } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  return (
    <InView as='div' onChange={inView => setIsVisible(inView)} className={`work-process-section section-gap d-flex align-start ${classes}`} id={props.id ? props.id : ''}>
      <div className="container">
        <div className="process-text-content">
          <h2 className="theme-color-title">{isVisible && <HeaderAnim header={title} />}</h2>
          <h3>{header} </h3>
          <p>{subHeader}</p>
        </div>
        <ul className="process-list">
          {items.map((item, index) => {
            return (<li key={index} className={item.class}>
              <div className="item-inner">
                <div className="grid-icon white-bg">
                  <i className="icon-small">{item.icon}</i>
                </div>
                <p>{item.name}</p>
              </div>
            </li>);
          })}
        </ul>
      </div>
    </InView>
  );
}